<template>
    <div style="width: 95%;float: left">
        <div class="Header_part">
            <div style="width: 50%; text-align:right;float: left;margin-left: 5%">
                <Input search placeholder="">
                    <Select v-model="searchType" @on-change="initial_data" slot="prepend" style="width: 130px">
                        <Option value="untreated">Untreated</Option>
                        <Option value="pass">Pass</Option>
                        <Option value="refuse">Reject</Option>
                    </Select>
                </Input>
            </div>

            <div style="width: 30%; text-align:right;float: right; margin-right: 5%">
               <!-- <Dropdown style="margin-left: 20px">
                    <Button type="primary">
                        {{filterType}}
                        <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu slot="list" style="text-align: left" @on-click="dpchange">
                        <DropdownItem name="untreated">Untreated</DropdownItem>
                        <DropdownItem name="pass">Pass</DropdownItem>
                        <DropdownItem name="reject">Reject</DropdownItem>
                    </DropdownMenu>
                </Dropdown>-->
            </div>
            <!-- 主要是规则，和还能拒绝的数量， 当前的owner-->
        </div>
        <div style="width: 90%; float: left; margin-left: 5%; margin-top: 10px; padding-bottom: 50px">
            <Row style="padding: 1rem; border-radius: 5px 5px 0 0; background-color: #F5F5F5   ; border: #c8e1ff solid 0.0625rem;">
                <Col span="12" style="text-align: left;">
                    <span style="font-size: 1rem; font-weight: 400; margin-left: 0.5rem;">{{ message }}</span>
                </Col>
            </Row>
            <div class="codeTable">
                    <List border :data="codeTableData">
                        <ListItem v-for="item in codeTableData" :key="item.id" style="text-align: left; padding-left: 5%">
                            <Avatar icon="ios-person" size="40"/>
                            <ListItemMeta :title="item.userName" :description="item.type" style="text-align: left; padding-left: 5%"/>
                            <template slot="action">
                                <!--<li>
                                    <Button v-if="item.applicationType === 1" style="color:#e9ab01">
                                        This application is being audited . . .
                                    </Button>
                                    <Button v-else-if="item.applicationType === 2"  style="color:#13AF5F">
                                        This application has been approved.
                                    </Button>
                                    <Button v-else style="color:#D13819">
                                        This application has been rejected.
                                    </Button>
                                </li>-->
                                <li>
                                  <a :href="'/#/checkJoinInfo?id='+projectId+ '&jid='+ item.id"> <Icon type="ios-arrow-forward" /> </a>
                                </li>
                            </template>
                        </ListItem>
                    </List>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "checkJoinList",
        data(){
            return{
                searchType: 'untreated',
                filterType:'untreated',
                message:'',
                projectId:'',
                data1: [
                    {
                        branchName: 'main',
                        IsdDefault: '(default)'
                    },
                    {
                        branchName: 'frontend',
                        IsdDefault: ''
                    },
                    {
                        branchName: 'backend',
                        IsdDefault: ''
                    },
                ],
                codeTableData:[]
            }
        },
        methods: {
            initial_data(){
                var Tself = this;
                this.projectId = this.$route.query.id;
                //codeTableData获取所有的申请
                this.$axios({
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'post',
                    url: '/join/findByProjectIdAndStatus',
                    data: {
                        projectId: Tself.projectId,
                        status: Tself.searchType
                    }
                }).then(function (response) {
                        var items = response.data.data.items;//[{appl1, app2, app3}]
                    console.log(items);
                    var results = items.map(
                            function(obj){
                                var res = {}
                                res['id'] = obj.id;
                                res['userName'] = obj.username;
                                res['type'] = obj.type;
                                res['time'] = obj.time;
                                return res;
                            }
                        );
                        Tself.codeTableData = results;
                        console.log(results)
                }).catch(function (error) {
                        Tself.isMember = false;
                        console.log(error);
                });
            },
            check_detail(name) {

                this.$router.push('/checkJoinInfo')
            },
        },
        mounted() {
            this.initial_data();
        }
    }
</script>

<style scoped>
    .Header_part{
        width:100%;
        float:left;
        margin-top: 20px;
        margin-bottom: 15px;
    }
</style>
